import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { AIAgent } from '@nx-frontend/shared/types';

type ChatbotAgentStartProps = {
  agent: AIAgent;
  onRunClick: () => void;
};

export const ChatbotAgentStartView = (props: ChatbotAgentStartProps) => {
  return (
    <div className="overflow-y-auto flex flex-col h-full pt-5">
      <div className="rounded-lg border border-[zinc-100] bg-[radial-gradient(191.81%_165.86%_at_70.71%_25.88%,_#FAFAFA_0%,_#F0FDFA_100%)] p-4 flex flex-col ml-6 mr-6 mb-6 mt-auto">
        <div className="text-[16px] leading-[148%] text-neutral-800">{props.agent.description}</div>

        <div className="flex justify-center mt-[18px]">
          <Button type={ButtonType.FLAT} size={ButtonSize.MD} onClick={props.onRunClick}>
            Run task
          </Button>
        </div>
      </div>
    </div>
  );
};
